import type { SxProps, Theme } from '@mui/material/styles';

export function autocompleteSizeSx(size: 'small' | 'medium'): SxProps<Theme> {
  // The input root inherits the surface it sits on (dialog `background.paper`,
  // hero bar surface, etc.) so it visually matches plain outlined text inputs
  // nearby; we explicitly null out `quickSearchInputSx`'s `background.paper`
  // override at the higher-specificity selector because MUI Autocomplete with
  // `multiple` paints the input root a hair darker, which read as a different
  // surface against the dialog in dark mode.
  if (size === 'small') {
    return {
      '& .MuiInputBase-root': {
        height: 'auto',
        minHeight: { xs: 32, md: 36 },
      },
      '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
        height: 'auto',
        minHeight: { xs: 32, md: 36 },
        flexWrap: 'wrap',
        alignItems: 'center',
        backgroundColor: 'transparent',
        paddingTop: '2px',
        paddingBottom: '2px',
        paddingLeft: '6px',
        paddingRight: '32px !important',
        fontSize: '16px', // iOS Safari auto-zooms inputs with font-size < 16px and doesn't zoom back out
      },
      '& .MuiAutocomplete-input': {
        py: '4px',
        minHeight: 0,
      },
    };
  }
  return {
    '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
      height: 'auto',
      minHeight: '48px',
      flexWrap: 'wrap',
      backgroundColor: 'transparent',
      paddingTop: '5px',
      paddingBottom: '5px',
      paddingRight: '40px !important',
    },
  };
}
